import { render, staticRenderFns } from "./comp-info-input.vue?vue&type=template&id=8328f1dc&scoped=true"
import script from "./comp-info-input.vue?vue&type=script&lang=js"
export * from "./comp-info-input.vue?vue&type=script&lang=js"
import style0 from "./comp-info-input.vue?vue&type=style&index=0&id=8328f1dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.98.0_@swc+core@_6e87fc85b9f10127a07f7770afd491e7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8328f1dc",
  null
  
)

export default component.exports